import { render, staticRenderFns } from "./ChatsListContainer.vue?vue&type=template&id=508ddeb2"
import script from "./ChatsListContainer.vue?vue&type=script&lang=js"
export * from "./ChatsListContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports